import { RelayApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { AxiosRequestConfig } from 'axios';

export const useGetRelayFancyShareQuery = (fancyShareId: number) =>
  useQuery({ queryKey: relayQueryKey.fancyShare(fancyShareId), queryFn: () => RelayApi.fancyShare(fancyShareId) });

export const prefetchRelayFancyShareQuery = async (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  fancyShareId: number,
) =>
  queryClient.prefetchQuery({
    queryKey: relayQueryKey.fancyShare(fancyShareId),
    queryFn: () => RelayApi.fancyShare(fancyShareId, options),
  });
